import {
  AuthContentVM,
  DEFAULT_AUTH_CONTENT,
} from '@porterin/booking-flow/src/auth/view-model/auth-content/AuthContentVM';
import React from 'react';

export const context = React.createContext<AuthContentVM>(DEFAULT_AUTH_CONTENT);

export const useAuthContentContext = (): AuthContentVM =>
  React.useContext(context);
